import { Link, useLocation } from 'react-router-dom'

import { useI18n } from '@/lib/i18n'
import { tournamentHallUrl } from './archive-state'

export function TournamentModuleNavigation({
  active,
  tournamentPath,
}: {
  active: 'tournament' | 'hall'
  tournamentPath: string
}) {
  const { t } = useI18n()
  const location = useLocation()
  return (
    <nav
      data-testid="tournament-module-navigation"
      aria-label={t('tournament.entry')}
      className="mb-[26px] flex gap-7 border-b border-border text-[15px] text-muted-foreground"
    >
      {[
        { key: 'tournament', title: t('tournament.entry'), to: tournamentPath },
        {
          key: 'hall',
          title: t('tournamentHall.title'),
          to: tournamentHallUrl(location),
        },
      ].map(item => (
        <Link
          key={item.key}
          to={item.to}
          data-testid={
            item.key === 'hall'
              ? 'tournament-hall-link'
              : 'tournament-module-entry'
          }
          aria-current={active === item.key ? 'page' : undefined}
          className={`inline-flex min-h-12 items-center border-b-2 px-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${active === item.key ? 'border-primary font-semibold text-foreground' : 'border-transparent hover:text-foreground'}`}
        >
          {item.title}
        </Link>
      ))}
    </nav>
  )
}
